<fieldset *ngIf="configurationClass" [formGroup]="maintenanceSummary">
  <legend>
    <ng-container *ngIf="aircraft$ | async; let aircraft">
      {{ aircraft.tailNumber }} ({{ aircraft.model }})
    </ng-container>
    Maintenance Summary
    <a
      *ngIf="aircraftId && (isAviationSupervisor$ | async)"
      [routerLink]="'/maintenance/parameters/' + aircraftId!"
      >Manage Maintenance Parameters</a
    >
    <fl-maintenance-image-control
      *ngIf="flightLogId"
      [flightLogId]="flightLogId"
    ></fl-maintenance-image-control>
  </legend>
  <div data-row-span="12">
    <div data-field-span="3" class="readonly">
      <label>Starting Hobbs</label>
      <input type="number" [readonly]="true" formControlName="startingHobbsReading" min="0" />
    </div>
    <div data-field-span="3">
      <label>Ending Hobbs</label>
      <input type="number" formControlName="endingHobbsReading" min="0" />
    </div>
    <div data-field-span="2" class="readonly">
      <label>Flight Time</label>
      <input type="number" [readonly]="true" formControlName="totalFlightTime" min="0" />
    </div>
    <div data-field-span="2" class="readonly">
      <label>
        Total Landings
        <span *ngIf="previousMaintenanceTotals" title="{{ landingsTotalTooltip$ | async }}">
          {{ landingsTotalDisplay$ | async }}
        </span>
      </label>
      <input type="number" readonly formControlName="totalLandings" min="0" />
    </div>
    <div data-field-span="2" [ngClass]="{ readonly: !isTraining }">
      <label>
        Run On Landings
        <span *ngIf="previousMaintenanceTotals" title="{{ runOnLandingsTotalTooltip$ | async }}">
          {{ runOnLandingsTotalDisplay$ | async }}
        </span>
      </label>
      <input *ngIf="!isTraining" type="number" readonly formControlName="runOnLandings" min="0" />
      <input *ngIf="isTraining" type="number" formControlName="runOnLandings" min="0" />
    </div>
  </div>
  <fl-engine-maintenance
    *ngIf="showEngineOne"
    [maintenanceParameters]="configurationClass?.maintenanceParameters"
    [engine]="maintenanceSummary.get('engine1')"
    [engineNumber]="1"
    [previousTotals]="previousMaintenanceTotals?.engine1"
  ></fl-engine-maintenance>
  <fl-engine-maintenance
    *ngIf="showEngineTwo"
    [maintenanceParameters]="configurationClass?.maintenanceParameters"
    [engine]="maintenanceSummary.get('engine2')"
    [engineNumber]="2"
    [previousTotals]="previousMaintenanceTotals?.engine2"
  ></fl-engine-maintenance>
  <fl-maintenance-part133
    *ngIf="isFlightTypePart133"
    [maintenanceSummary]="maintenanceSummary"
  ></fl-maintenance-part133>
  <div data-row-span="12">
    <div data-field-span="3" class="readonly">
      <label>Previous Aircraft Time</label>
      <input type="number" [formControl]="previousAirframeTimeCtrl" min="0" />
    </div>
    <div data-field-span="3">
      <label>Increment</label>
      <input type="number" formControlName="airframeTime" min="0" />
    </div>
    <div data-field-span="2" class="readonly">
      <label>Total</label>
      <input type="number" [readonly]="true" [formControl]="totalAirframeTimeCtrl" min="0" />
    </div>
  </div>
</fieldset>
<fl-message-box [messages]="validationErrors$ | async" [level]="'error'"></fl-message-box>
